<template>
  <v-dialog v-model="dialogframeboton" persistent fullscreen>
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title> Formulario Dinámico </v-toolbar-title>
        <v-toolbar-items>
          <v-btn dark text @click="dialogframeboton = !dialogframeboton"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <!-- Formulario Dinamico ¡-->
        <card-formulario :formularioId="formId"> </card-formulario>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-data-table
    :headers="headers"
    :items="desserts"
    :search="search"
    item-value="name"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <!-- Buscador -->
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <!-- Consulta de documento  -->
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            @click="IconosFormulario(item.raw)"
            color="primary"
            icon="mdi-file-document"
            size="x-small"
          ></v-btn>
        </template>
        <span>Generar formulario</span>
      </v-tooltip>
    </template>
  </v-data-table>

  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import FormularioDinamico from "@/views/TCI/Formularios/FormularioDinamico/FormularioDinamico.vue";
export default {
  components: {
    "card-formulario": FormularioDinamico,
  },
  name: "ConsultaFormularios",
  data() {
    return {
      progreso: false,
      dialogframeboton: false,
      search: null,
      headers: [
        {
          title: "Acciones",
          align: "center",
          sortable: false,
          key: "actions",
        },
        {
          title: "Formulario ID:",
          align: "left",
          key: "FormularioId",
        },
        {
          title: "Nombre Formulario",
          align: "left",
          key: "DescFormularioId",
        },
        {
          title: "Tipo de Formulario",
          align: "left",
          key: "DescTipoFormulario",
        },
        {
          title: "Fecha de Creación",
          align: "left",
          key: "FechaCreacion",
        },
      ],
      desserts: [],
      param1: "",
      UsuarioLogin: "",
      formId: 0,
    };
  },
  ///////////////////////////////////////////////// Métodos de Watch ///////////////////////////////////////////
  watch: {
  },

  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Consulta Reportes
    async getReporte() {
      this.progreso = true;
      this.axios
        .get(
          "/Formularios/Formulario/GetConsultaFormulariosDinamico?grupo=" +
            this.param1
        )
        .then((result) => {
          if (result.data.Status == 200) {
            this.desserts = result.data.Data;
          } else {
            this.$swal({
              icon: "warning",
              title: "Consulta inexistente.",
              html: result.data.Message,
            });
          }
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen datos para esta consulta.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    IconosFormulario(inforeporte) {
      this.dialogframeboton = true;
      this.formId = inforeporte.FormularioId;
    },

    // Busca los parametros de la pagina
    parametrospaginas() {
      var page = this.$store.getters.userperfil.paginainfo;
      if (page.param1) {
        this.param1 = page.param1;
      }
      this.getReporte();
    },
  },
  mounted() {
    this.parametrospaginas();
    var userperfil = this.$store.getters.userperfil;
    this.UsuarioLogin = userperfil.userInfo.Usuario_ID;
  },
};
</script>
